import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Layout from "../../layout/Layout";
import ThemeIconForm from "./ThemeIconForm";
import FormSkeleton from "../../Component/theme-management/FormSkeleton";
import ErrorState from "../../Component/theme-management/ErrorState";
import { Card } from "react-bootstrap";
import { iconsApi, isAuthError } from "../../helpers/tmClient";

/** Edit Theme Icon page — loads the icon then renders the form. */
const ThemeIconEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [icon, setIcon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const load = async () => {
    setLoading(true);
    setLoadError(false);
    try {
      const res = await iconsApi.detail(id);
      if (isAuthError(res)) return navigate("/");
      if (res.data.status && res.data.data) setIcon(res.data.data);
      else {
        toast.error("Icon not found", { position: "bottom-right", autoClose: 1000 });
        navigate("/theme-icons");
      }
    } catch {
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Layout sidebar={true}>
        <div className="page-heading"><h3 className="my-1">Edit Icon Set</h3></div>
        <div className="page-content">
          <FormSkeleton fields={2} images={1} />
        </div>
      </Layout>
    );
  }
  if (loadError) {
    return (
      <Layout sidebar={true}>
        <div className="page-heading"><h3 className="my-1">Edit Icon Set</h3></div>
        <div className="page-content">
          <Card><Card.Body>
            <ErrorState asRow={false} message="Failed to load icon set." onRetry={load} />
          </Card.Body></Card>
        </div>
      </Layout>
    );
  }
  return icon ? <ThemeIconForm mode="edit" initial={icon} /> : null;
};

export default ThemeIconEdit;
